"use strict";

import { initEmailSignup } from "./components/emailSignup";

$(document).ready(function () {
    initEmailSignup();
});
